module.exports = __webpack_public_path__ + "img/VTAFvsOTP.88cbdb51.png";